import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import barquette300 from "@/assets/products/barquette-bateau-300ml.png";
import barquette400 from "@/assets/products/barquette-bateau-400ml.png";
import barquette680 from "@/assets/products/barquette-bateau-680ml.jpg";
import barquette1000 from "@/assets/products/barquette-bateau-1000ml.png";

const config: ProductPageConfig = {
  name: "Barquettes bateau en carton kraft",
  breadcrumbName: "Barquettes bateau",
  subtitle: "Idéales pour frites, snacks, tapas et finger food",
  features: ["Contact alimentaire", "Recyclable", "Résistant aux graisses", "FSC certifié", "Disponible en stock"],
  variants: [
    { ref: "GTRAY10OZ", capacity: "300 ml (10 oz)", dimensions: "100 x 62 x 44 mm", material: "Carton kraft", packaging: "Carton de 1 000 (10 x 100)", palette: "42 cartons", image: barquette300 },
    { ref: "GTRAY13OZ", capacity: "400 ml (13 oz)", dimensions: "106 x 73 x 46 mm", material: "Carton kraft", packaging: "Carton de 500 (5 x 100)", palette: "42 cartons", image: barquette400 },
    { ref: "GTRAY23OZ", capacity: "680 ml (23 oz)", dimensions: "136 x 85 x 55 mm", material: "Carton kraft", packaging: "Carton de 500 (5 x 100)", palette: "35 cartons", image: barquette680 },
    { ref: "GTRAY32OZ", capacity: "1 000 ml (32 oz)", dimensions: "170 x 97 x 57 mm", material: "Carton kraft", packaging: "Carton de 200 (10 x 50)", palette: "13 cartons", image: barquette1000 },
  ],
};

const BarquettesBateau = () => <ProductPageLayout config={config} />;
export default BarquettesBateau;
